<template>
  <div class="page-add">
    <div class="add-title">{{ !editId ? "新增中组部选调班" : "编辑中组部选调班" }}</div>
    <el-form class="form" size="small" label-position="right" label-width="130px" :rules="rules" :model="classForm"
      ref="classForm">
      <el-row>
        <el-col :span="4">
          <el-form-item label="班级名称：" prop="classYear">
            <el-date-picker class="year_style" align="center" v-model="classForm.classYear" type="year"
              value-format="yyyy" format="yyyy" placeholder="选择年份" :disabled="!!editId" @change="yearChange">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="60px" prop="className">
            <el-input v-model="classForm.className" placeholder="请输入班级名称">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主办单位：" prop="organizerIds">
            <!-- <el-input v-model="classForm.organizer" placeholder="请输入主办单位"></el-input> -->
            <el-select
              v-model="classForm.organizerIds"
              placeholder="请选择主办单位"
              multiple
              class="select"
              style="width: 64%"
              @change="changeOrganizer"
            >
              <el-option
                v-for="(item, i) in classDropList"
                :key="i"
                :label="item.organizerName"
                :value="item.uuid"
              ></el-option>
            </el-select>
            <el-button
              style="margin-left: 15px;"
                @click="toAddOrganizer"
              >去新增</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="班级类型：" prop="trainType">
            <!-- 切换成级联选择器 -->
            <el-cascader v-model="classForm.trainType" :options="treeCdata" :props="props" placeholder="请选择班级类型"
              style="width: 100%" @change="trainTypeChange" :disabled="!!editId">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="办班级别：" prop="classLevel">
            <el-select v-model="classForm.classLevel" class="select2" placeholder="请选择办班级别" style="width: 64%"
              filterable>
              <el-option v-for="item in classLevelList" :key="item.paramKey" :label="item.paramValue"
                :value="Number(item.paramKey)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item class="scale" label="报名部门：" prop="enrollDeptNames">
            <el-input class="form-dept" readonly v-model="classForm.enrollDeptNames" placeholder="请选择可报名部门"></el-input>
            <el-button class="button-dept" :disabled="
              !!editId &&
              Number(classForm.publishStatus) == 1 &&
              Number(classForm.trainType[1]) == 15
            " @click="selectDep">选择</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报名时间：" prop="enrollTime">
            <el-date-picker unlink-panels v-model="classForm.enrollTime" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              @change="enrollTimeChange">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="班级专职管理员：" prop="auditUserIds" :rules="[rulesFactory.required('请选择班级专职管理员')]">
            <el-select v-model="classForm.auditUserIds" class="select2" multiple placeholder="请选择班级专职管理员"
              style="width: 64%" filterable>
              <el-option v-for="item in auditUserList" :key="item.uuid" :label="item.userName"
                :value="String(item.uuid)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学期：" prop="classSemester">
            <el-select v-model="classForm.classSemester" class="select2" placeholder="请选择学期" style="width: 64%"
              filterable>
              <el-option v-for="item in semesterList" :key="item.paramKey" :label="item.paramValue"
                :value="Number(item.paramKey)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="报到时间：" prop="clockTime">
            <el-date-picker unlink-panels v-model="classForm.clockTime" type="datetimerange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
              @change="clockTimeChange" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报到地点：" prop="clockPlace" :rules="[rulesFactory.required('请输入报到地点')]">
            <el-input v-model="classForm.clockPlace"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="培训时间：" prop="trainTime">
            <el-date-picker unlink-panels v-model="classForm.trainTime" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              @change="changeTrainTime">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学制：" prop="trainDays" :rules="[rulesFactory.required('请输入学制')]">
            <el-input v-model="classForm.trainDays" oninput="value=value.replace(/[^0-9.]/g,'')"
              @input="limitInput"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item :label="boringLabel" prop="trainPlace" :rules="[rulesFactory.required('请输入培训地点')]">
            <el-input v-model="classForm.trainPlace" placeholder="请输入培训地点"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="选调要求：" prop="desc" :rules="[
            rulesFactory.required('请输入选调要求'),
            rulesFactory.size('最多输入200个字', 0, 200),
          ]">
            <el-input type="textarea" rows="3" v-model="classForm.desc" placeholder="请输入选调要求" show-word-limit
              maxlength="200"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="承办单位：" prop="undertakeUnitNumber" :rules="[rulesFactory.required('请选择承办单位')]">
            <el-select v-model="classForm.undertakeUnitNumber" class="select2" placeholder="请选择承办单位" style="width: 64%"
              filterable>
              <el-option v-for="item in organizerList" :key="item.paramKey" :label="item.paramValue"
                :value="Number(item.paramKey)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="计划人数：" prop="planStuNum" :rules="[rulesFactory.required('请选择计划人数')]">
            <el-input-number class="input" v-model="classForm.planStuNum" :min="1" :max="1000000" :step="10">
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle form-text-center" label-width="0">
            <el-button @click="resetForm" v-show="!editId">重置</el-button>
            <el-button @click="$router.push({ path: '/centerSelectClass' })">返回</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <dept :enrollDeptVos="checkedEnrollDeptVos" @enrollDeptSelected="enrollDeptSelected" />
  </div>
</template>

<script>
import moment from "moment";
import { getEnrollAuditorList, getClassDropList } from "@/api/class";
import {
treeChildVos
} from "@/api/classOffline";
import { getTopDepts } from "@/api/dept";
import { classTransferringInfoNew, classTransferringSave, classTransferringUpdate } from '@/api/studyService';
import { BaseConfirm } from "@/components/Confirm";
import vue from "@/main";
import { getEnums } from '@/utils/common.js';
import rulesFactory from "@/utils/rules";
import { setItem } from "@/utils/storage.js";
import { compareDate, compareDateNotEqual, getDaysBetween } from "@/utils/timeFormat";
import Dept from '@/views/onlineClass/add/deptNew.vue';
export default {
  name: "centerSelectClassEdit",
  props: {},
  components: { Dept },
  data() {
    let checkEnrollTime = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error("请选择报名时间"));
      } else {
        callback();
      }
    };
    // 添加培训时间校验函数
    let checkTrainTime = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error("请选择培训时间"));
      } else {
        // 培训时间不能超出班级年度范围 - 仅当年份存在时判断
        if (this.classForm.classYear && 
            (moment(value[0]) < moment(`${this.classForm.classYear}-01-01`, "YYYY-MM-DD 00:00:00") ||
            moment(value[0]) >= moment(`${parseInt(this.classForm.classYear) + 1}-01-01`, "YYYY-MM-DD 00:00:00"))) {
          callback(new Error("培训开始时间不能超出班级年度范围"));
        } 
        // 培训开始时间必须晚于报名结束时间 - 仅当报名时间存在时判断
        else if (this.classForm.enrollTime && this.classForm.enrollTime.length === 2 && this.classForm.enrollTime[1] &&
                moment(value[0]) <= moment(this.classForm.enrollTime[1])) {
          callback(new Error("培训开始时间必须晚于报名结束时间"));
        } 
        // 培训开始时间不能早于报到结束时间 - 仅当报到时间存在时判断
        else if (this.classForm.clockTime && 
                this.classForm.clockTime.length === 2 && 
                this.classForm.clockTime[1] &&
                moment(value[0]) < 
                moment(this.classForm.clockTime[1])) {
          callback(new Error("培训开始时间不能早于报到结束时间"));
        } 
        else {
          callback();
        }
      }
    };
    return {
      props: {
        //树形
        value: "key",
        label: "name",
        children: "children",
        // checkStrictly: true,
      },
      classLevelList: [],
      treeCdata: [],
      classTypeList: [],
      semesterList: [],
      organizerList: [],
      rulesFactory,
      auditUserList: [],
      topDeptList: [],
      checkedEnrollDeptVos: [],
      cascaderProps: {
        value: "key",
        label: "name",
        children: "children",
      },
      boringLabel: "培训地点：",
      editId: null,
      classForm: {
        classYear: "",
        className: "",
        organizer: "",
        trainType: [],
        enrollDeptNames: "",
        enrollTime: [],
        enrollDeptIds: [],
        auditUserIds: [],
        clockTime: [],
        trainTime: [],
        clockPlace: "",
        trainDays: null,
        trainPlace: null,
        desc: "",
        undertakeUnitNumber: null,
        planStuNum: 0,
        classLevel: 0,
        organizerIds: []
      },
      rules: {
        classYear: [rulesFactory.required("请选择年份")],
        className: [
          rulesFactory.required("请输入班级名称"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        organizerIds: [
          rulesFactory.required("请选择主办单位")
        ],
        trainType: [rulesFactory.required("请选择班级类型")],
        enrollDeptNames: [rulesFactory.required("请选择报名部门")],
        enrollTime: [
          { required: true, validator: checkEnrollTime, trigger: "blur" },
        ],
        classLevel: [rulesFactory.required("请选择办班级别")],
        trainTime: [
          { required: true, validator:checkTrainTime, trigger:"blur" },
        ],
      },
      classDropList: []
    };
  },
  created() {
    this.getClassDropList();
    getEnums(['CLASS_SEMESTER', 'UNDERTAKE_UNIT', 'CLASS_TYPE_NEW', 'SELECTED_CLASS_LEVEL_TYPE'], this, ['semesterList', 'organizerList', 'classTypeList', 'classLevelList'], [false, false, false, false])
    this.editId = this.$route.query.id || null;
    if (this.editId) {
      this.initEdit();
    } else {
      this.initAdd()
    }
  },
  methods: {
    changeOrganizer(val){
      
    },
    // 添加年份变化时触发培训时间校验
    yearChange() {
      if (this.classForm.trainTime && this.classForm.trainTime.length > 0) {
        this.$refs.classForm.validateField('trainTime');
      }
    },
    
    // 报名时间变化时触发培训时间校验
    enrollTimeChange() {
      if (this.classForm.trainTime && this.classForm.trainTime.length > 0) {
        this.$refs.classForm.validateField('trainTime');
      }
    },
    
    // 报到时间变化时触发培训时间校验
    clockTimeChange() {
      if (this.classForm.trainTime && this.classForm.trainTime.length > 0) {
        this.$refs.classForm.validateField('trainTime');
      }
    },
    
    // 培训时间变化时触发自身校验
    changeTrainTime() {
      this.$refs.classForm.validateField('trainTime');
    },

    // 获取主办单位-列表
    getClassDropList() {
      let params = {
        type: 2 // type=1:线上线下，type=2：中组部
      };
      getClassDropList(params).then((res) => {
        if (!res || res.code != 0) return;
        this.classDropList = res.data;
      })
    },
    limitInput(value) {
      if (value != "") {
        let inputValue = value;
        if (value.indexOf(".") > -1) {
          inputValue = value.slice(0, value.indexOf(".") + 3);
        }
        this.classForm.trainDays = inputValue
      }
    },

    initEdit() {
      classTransferringInfoNew({ uuid: this.editId }).then(({ code, data }) => {
        if (code !== 0) return
        let obj = Object.assign({}, data);
        this.getCanAudit(
          obj.enrollDeptVos.map((ele) => ele.deptLevelCode),
          false
        );
        obj.enrollTime = [obj.enrollStartTime, obj.enrollEndTime]
        obj.trainTime = [obj.trainStartTime, obj.trainEndTime]
        obj.clockTime = [obj.clockStartTime, obj.clockEndTime]
        delete obj.enrollStartTime;
        delete obj.enrollEndTime;
        delete obj.trainStartTime;
        delete obj.trainEndTime;
        delete obj.clockStartTime;
        delete obj.clockEndTime
        this.classForm = obj;
        treeChildVos({ type: "CLASS_TYPE" }).then((res) => {
          if (!res || res.code != 0) return;
          let tg = this.classForm.trainType;
          let tt = [0, String(tg)];
          this.treeCdata = res.data || [];
          this.treeCdata.forEach((x) => {
            if (x.children) {
              x.children.forEach((y) => {
                if (y.key == tt[1]) {
                  tt[0] = x.key;
                }
              });
            }
          });
          this.classForm.trainType = tt;

          console.log(this.classForm, tt);
        });
        this.classForm.enrollDeptIds = this.classForm.enrollDeptVos.map(
          (ele) => ele.deptId
        );
        this.checkedEnrollDeptVos = this.classForm.enrollDeptVos;
      })
      // 


    },
    initAdd() {
      this.classForm.classYear = new Date().getFullYear().toString();
      treeChildVos({ type: "CLASS_TYPE_NEW" }).then((res) => {
        if (!res || res.code != 0) return;
        this.treeCdata = res.data;
      });
    },
    trainTypeChange(val) {
      console.log(val);
      if (val[1] == 23) {
        this.boringLabel = "培训国家：";
      } else {
        this.boringLabel = "培训地点：";
      }
    },
    selectDep() {
      vue.$emit("selectDep");
    },
    enrollDeptSelected(dept) {
      this.$set(this.classForm, "enrollDeptIds", dept.ids);
      // this.defaultCheckedKeys = dept.ids;
      this.$set(this.classForm, "enrollDeptVos", dept.enrollDeptVos);
      this.checkedEnrollDeptVos = this.classForm.enrollDeptVos;
      this.classForm.enrollDeptNames = dept.names.join(",");
      this.getTopDepts(dept.enrollDeptVos);
    },
    getTopDepts(nodeArr) {
      getTopDepts(nodeArr).then((res) => {
        if (!res || res.code != 0) return;
        this.topDeptList = res.data || [];
        this.getCanAudit(
          this.topDeptList.map((ele) => ele.deptLevelCode),
          true
        );
      });
    },
    getCanAudit(levelCodes, flag) {
      getEnrollAuditorList(levelCodes).then((res) => {
        if (!res || res.code != 0) return;
        this.auditUserList = res.data || [];
        if (flag) {
          this.classForm.auditUserIds = [];
        }
      });
    },
    submit() {
      const api = !this.editId ? classTransferringSave : classTransferringUpdate
      console.log('this.classForm :>> ', this.classForm);
      this.$refs["classForm"]
        .validate()
        .then(() => {
          let params = Object.assign({}, this.classForm);

          params.enrollStartTime = params.enrollTime[0] || ''
          params.enrollEndTime = params.enrollTime[1] || ''
          // trainTime
          params.trainStartTime = params.trainTime[0] || ''
          params.trainEndTime = params.trainTime[1] || ''
          // clockTime
          params.clockStartTime = params.clockTime[0] || ''
          params.clockEndTime = params.clockTime[1] || ''

          params.trainType = this.classForm.trainType[1];
          delete params.enrollDeptNames;
          if (this.topDeptList && this.topDeptList.length > 0) {
            params["enrollDeptVos"] = JSON.parse(JSON.stringify(this.topDeptList));
            params["enrollDeptIds"] = this.topDeptList.map((ele) => ele.deptId);
          }
          delete params["clockTime"]
          delete params["enrollTime"]
          delete params["trainTime"]
          api(params).then(({ code, msg }) => {
            if (code !== 0) return;
            setItem(this.REFRESH_FLAG, true);
            this.$message.success(msg)
            this.$router.push({ path: "/centerSelectClass" });
          })
        })
    },
    // 重置表单数据
    async resetForm() {
      const flag = await BaseConfirm("确定重置吗?");
      if (!flag) return;
      let className = this.classForm.className;
      Object.assign(this.$data.classForm, this.$options.data().classForm);
      this.classForm.className = className;
    },
    toAddOrganizer() {
      this.$router.push({
        path: "/sponsorManage",
      });
    },
  }
}
</script>
<style lang='scss' scoped>
$textColor: #51627d;

.year_style {
  margin-right: 10px;
  color: #51627d;
}

/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}

/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}

.form-select {
  width: 100%;
}

.form-select2 {
  width: calc(100% - 30px);
  margin-bottom: 16px;
  margin-right: 8px;
}

/deep/ .el-form-item__content {
  .form-dept {
    width: calc(100% - 90px) !important;
    font-size: inherit;
  }

  .form-dept2 {
    width: calc(50% - 90px) !important;
    font-size: inherit;
  }

  .button-dept {
    margin-left: 10px;
    padding: 9px 15px;
    width: 79px;
  }

  .el-select.select {
    width: calc(100% - 90px) !important;
  }
  .el-select.select2 {
    width: 100% !important;
  }
}

.year_style {
  // width: 145px;
  margin-right: 10px;
  color: #51627d;
}

/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}

.form-text-center {
  text-align: center !important;
}


/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}

/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}

.form-select {
  width: 100%;
}

/deep/ .el-form-item__content {
  .form-dept {
    width: calc(50% - 139px);
    font-size: inherit;
  }

  .button-dept {
    margin-left: 10px;
    padding: 9px 15px;
    width: 79px;
  }

}
</style>